<template>
  <view class="goods-page">
    <!--  轮播  -->
    <view class="carousel">
      <swiper indicator-dots circular="true" duration="400">
        <swiper-item v-for="(item, index) in goodsDetail.post.content.gallery" :key="index" class="swiper-item">
          <view class="image-wrapper">
            <image :src="imgPath + item" class="loaded" mode="aspectFill"></image>
          </view>
        </swiper-item>
      </swiper>
    </view>
    <!--  商品简介  -->
    <view class="introduce-section">
      <view class="name-wrap">
        <view>
          <text v-if="goodsDetail.nameSpu" class="title">{{ goodsDetail.nameSpu }}</text>
          <text v-else class="title" style="opacity: 0"> 商品详情 </text>
        </view>
      </view>
      <view class="price-box">
        <text class="price-tip">¥</text>
        <text v-if="goodsDetail.priceFrom < goodsDetail.priceTo" class="price"
          >{{ goodsDetail.priceFrom }}-{{ goodsDetail.priceTo }}</text
        >
        <text v-else-if="goodsDetail.priceFrom" class="price">{{ goodsDetail.priceFrom }}</text>
        <text v-else class="price" style="opacity: 0">0</text>
      </view>
      <view class="bot-row">
        <text v-if="goodsDetail.sellSpu">销量: {{ goodsDetail.sellSpu }}</text>
        <text v-else>销量: 0</text>
        <text v-if="goodsDetail.transportFee && goodsDetail.transportFee !== 0"
          >快递: ¥{{ goodsDetail.transportFee }}</text
        >
        <text v-else-if="goodsDetail.transportFee && goodsDetail.transportFee === 0">快递: 包邮</text>
        <text v-else>快递: -- </text>
      </view>
    </view>
    <!--  规格选择  -->
    <view>
      <u-cell-group>
        <u-cell-item title="已选" arrow @click="toggleSpec('select')">
          <text v-for="(sItem, sIndex) in specSelected" :key="sIndex">
            {{ sItem.labelTag === 'normal' ? '默认' : sItem.name }}
          </text>
        </u-cell-item>
      </u-cell-group>
    </view>
    <!--  图文详情  -->
    <view class="detail-desc">
      <view class="d-header">
        <text>图文详情</text>
      </view>
      <view v-for="(itemCnt, indexCnt) in goodsDetailContent" :key="indexCnt" class="desc-content">
        <view v-if="itemCnt.type === 'text'" class="desc-text-view">
          <text>{{ itemCnt.content }}</text>
        </view>
        <view v-if="itemCnt.type === 'image'" class="desc-image-view">
          <image :src="imgPath + itemCnt.content" class="loaded" mode="widthFix"></image>
        </view>
      </view>
    </view>

    <goods-action
      :cart-goods-num="cartGoodsNum"
      @goToCart="goToCart"
      @buyNow="toggleSpec('buyNow')"
      @addToCart="toggleSpec('addCart')"
    ></goods-action>
    <!--  规格弹窗  -->
    <u-popup v-model="showSpecPop" mode="bottom">
      <view class="attr-content">
        <view class="a-t">
          <image
            class="selected-goods-image"
            :src="selectedGood ? imgPath + selectedGood.good.iconSku : imgPath + goodsDetail.iconSpu"
          ></image>
          <view class="right">
            <text class="price">¥{{ selectedGood ? selectedGood.good.price : '' }}</text>
            <text class="stock">库存：{{ selectedGood ? selectedGood.stock : '' }}件</text>
            <view class="selected">
              已选：
              <text v-for="(sItem, sIndex) in specSelected" :key="sIndex" class="selected-text">
                {{ sItem.labelTag === 'normal' ? '默认' : sItem.name }}
              </text>
            </view>
          </view>
        </view>
        <view v-for="(item, index) in specList" :key="index" class="attr-list">
          <text>{{ item.name }}</text>
          <view class="item-list">
            <text
              v-for="(childItem, childIndex) in specChildList"
              :style="{ display: childItem.pid !== item.id ? 'none' : '' }"
              :key="childIndex"
              class="spec-text"
              :class="{ selected: childItem.isThis && childItem.stock > 0, disableSelect: childItem.stock === 0 }"
              @click="selectSpec(index, childIndex, childItem)"
            >
              {{ childItem.labelTag === 'normal' ? '默认' : childItem.name }}
            </text>
          </view>
        </view>
        <text class="attr-list">数量</text>
        <u-number-box :v-model="cartNumBuy" :min="1" :max="selectedGood.stock" @change="onNumBuyChange"></u-number-box>
        <button
          v-if="showBtnType === 'addCart'"
          class="btn"
          :class="{ 'select-btn': selectedGood }"
          :disabled="!selectedGood"
          @click="handleAddToCart"
        >
          确定
        </button>
        <button
          v-if="showBtnType === 'buyNow'"
          class="btn"
          :class="{ 'select-btn': selectedGood }"
          :disabled="!selectedGood"
          @click="buy"
        >
          确定
        </button>
        <view v-if="showBtnType === 'select'" class="action-btn-group">
          <button
            type="primary"
            :class="{ 'add-cart-btn': selectedGood }"
            :disabled="!selectedGood"
            class="action-btn no-border"
            @click="handleAddToCart"
          >
            加入购物车
          </button>
          <button
            type="primary"
            :class="{ 'buy-now-btn': selectedGood }"
            :disabled="!selectedGood"
            class="action-btn no-border"
            @click="buy"
          >
            立即购买
          </button>
        </view>
      </view>
    </u-popup>
  </view>
</template>
<script>
import flattenDeep from 'lodash.flattendeep';
import cloneDeep from 'lodash.clonedeep';
import { queryGoodsDetail, queryCartList, addToCart } from '../../mall/api';
import { Setting, Utils } from '../../index';
import GoodsAction from '../goods-action/GoodsAction';
export default {
  name: 'GoodsDetail',
  props: {
    mid: {
      type: String,
      default: null,
    },
  },
  components: {
    GoodsAction,
  },
  data() {
    return {
      imgPath: Setting.getImgPath(),
      goodsDetail: null,
      goodsDetailContent: [],
      specList: [],
      specChildList: [],
      specSelected: [],
      selectedGood: null,
      goodsPrice: 0,
      showSpecPop: false,
      showBtnType: 'select',
      cartGoodsNum: 0,
      cartNumBuy: 1,
      choiceArray: [],
    };
  },
  mounted() {
    // console.log('%c [bbb]: ', 'color:#1989fa;', this.mid);
    this.getGoodsDetail(this.mid);
    this.getCartList(this.mid);
  },
  methods: {
    async getGoodsDetail(mid, choice = null) {
      const params = {
        mid,
      };
      if (choice) {
        params.choice = choice;
      }
      try {
        const goods = await queryGoodsDetail(params);
        console.log('%c [getGoodsDetail ok]: ', 'color:#1989fa;', goods);
        this.goodsDetail = goods;

        this.goodsPrice =
          this.goodsDetail.priceFrom === this.goodsDetail.priceTo
            ? this.goodsDetail.priceFrom
            : this.goodsDetail.priceFrom + '-' + this.goodsDetail.priceTo;
        if (this.goodsDetail && this.goodsDetail.post.content && this.goodsDetail.post.content.content) {
          this.goodsDetailContent = JSON.parse(this.goodsDetail.post.content.content);
        }
        // console.log('%c [post: ]: ', 'color:#1989fa;', this.goodsDetailContent);
        // 处理规格数据
        const specList = [];
        const specChildList = [];
        goods.stockArray.forEach(item => {
          specList.push({
            id: item[0].labelIndex,
            name: item[0].labelDesc,
          });
          item.forEach(subItem => {
            specChildList.push({
              pid: subItem.labelIndex,
              name: subItem.labelTxt,
              labelTag: subItem.labelTag,
              stock: subItem.stock,
              isThis: subItem.isThis,
            });
          });
        });
        this.specList = specList;
        this.specChildList = specChildList;
        // 选择规格后 对应的商品数据
        const stockArrayCp = flattenDeep(cloneDeep(goods.stockArray));
        const selectedGood = stockArrayCp.find(stockItem => stockItem.isThis === true);
        this.selectedGood = selectedGood;
        console.log('%c [selectedGood]: ', 'color:#1989fa;', selectedGood);
      } catch (e) {
        console.log('err', e);
        return e;
      }
    },
    // 切换规格弹窗的显示
    toggleSpec(showBtnType) {
      console.log('%c [切换规格弹窗的显示]: ', 'color:#1989fa;', showBtnType);
      this.showSpecPop = !this.showSpecPop;
      this.showBtnType = showBtnType;
    },
    /**
     * 选择规格
     * @param pIndex 规格的索引
     * @param index 规格里面的标签的索引
     * @param childItem 规格里面的标签
     */
    selectSpec(pIndex, index, childItem) {
      // console.log(' pIndex --> ', pIndex, index, childItem);
      const { pid, stock, labelTag } = childItem;
      if (stock === 0) return;
      let list = this.specChildList;
      list.forEach(item => {
        if (item.pid === pid) {
          this.$set(item, 'isThis', false);
        }
      });

      this.$set(list[index], 'isThis', true);

      this.specSelected = [];
      list.forEach(item => {
        if (item.isThis === true) {
          this.specSelected.push(item);
        }
      });
      console.log('this.specSelected --> ', this.specSelected);
      // 规格个数
      const len = this.specList.length;
      const choiceArray = this.choiceArray;
      // const isAllEmpty = choiceArray.every(item => item === '');
      if (choiceArray.length === 0) {
        // console.log('初始化 choiceArray --> ');
        for (let i = 0; i < len; i++) {
          choiceArray.push('');
        }
      }
      choiceArray[pIndex] = labelTag;
      console.log('choiceArray 2--> ', choiceArray);

      this.getGoodsDetail(this.mid, choiceArray);
    },
    // 获取购物车商品数量
    async getCartList() {
      try {
        const params = {
          query: {
            limit: 10,
            page: 0,
          },
        };
        const cartListByStore = await queryCartList(params);
        console.log('%c [cartList]: ', 'color:#1989fa;', cartListByStore);
        this.cartGoodsNum = flattenDeep(cartListByStore).length;
      } catch (e) {
        console.log('err', e);
        throw e;
      }
    },
    // 加入购物车
    async handleAddToCart() {
      try {
        const params = {
          form: {
            gid: this.selectedGood.good.gid,
            numBuy: this.cartNumBuy,
          },
        };
        await addToCart(params);
        await this.getCartList();
        this.cartNumBuy = 1;
        this.showSpecPop = false;
        uni.showToast({
          title: '加入购物车成功',
        });
      } catch (e) {
        uni.showToast({
          icon: 'error',
          title: '加入购物车失败',
        });
        this.cartNumBuy = 1;
        this.showSpecPop = false;
        throw e;
      }
    },
    // 修改数量
    onNumBuyChange({ value }) {
      console.log('%c [修改数量]: ', 'color:#1989fa;', value);
      this.cartNumBuy = value;
    },

    // 立即购买
    buy() {
      try {
        const { transport } = this.goodsDetail;
        const goodsTransport = Utils.parseTransport(transport);
        const {
          good: { gid },
        } = this.selectedGood;
        const orderForm = [
          {
            gid,
            transport: goodsTransport.indexOf(1) > -1 ? 1 : goodsTransport[0],
            address: ' ',
            note: '',
            numBuy: this.cartNumBuy,
            payMethodPick: 0, // 支付方式 0: 现金支付; >0: 混合支付,由商品支付方式决定
          },
        ];
        this.showSpecPop = false;
        // const createOrderUrl = `/demo/pages/mall/newOrder?orderForm=${JSON.stringify(orderForm)}`;
        // uni.navigateTo({
        //   url: createOrderUrl,
        // });
        this.$emit('createOrder', orderForm);
      } catch (e) {
        console.log('err', e);
        throw e;
      }
    },

    // 跳转购物车
    goToCart() {
      uni.navigateTo({
        url: '/demo/pages/mall/cart',
      });
    },
  },
};
</script>

<style scoped lang="scss">
$primary-color: #ee0a24;
.goods-page {
  .carousel {
    height: 722rpx;
    position: relative;
    swiper {
      height: 100%;
    }
    .image-wrapper {
      width: 100%;
      height: 100%;
    }
    .swiper-item {
      display: flex;
      justify-content: center;
      align-content: center;
      height: 750rpx;
      overflow: hidden;
      image {
        width: 100%;
        height: 100%;
      }
    }
  }
  /* 标题简介 */
  .introduce-section {
    background: #fff;
    padding: 20rpx 30rpx;
    .name-wrap {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    .title {
      font-size: 32rpx;
      color: #666;
      height: 50rpx;
      line-height: 50rpx;
    }
    .price-box {
      display: flex;
      align-items: baseline;
      height: 64rpx;
      padding: 10rpx 0;
      font-size: 26rpx;
      color: $primary-color;
    }
    .price {
      font-size: 34rpx;
    }
    .m-price {
      margin: 0 12rpx;
      color: #909399;
      text-decoration: line-through;
    }
    .coupon-tip {
      align-items: center;
      padding: 4rpx 10rpx;
      background: $primary-color;
      font-size: 24rpx;
      color: #fff;
      border-radius: 6rpx;
      line-height: 1;
      transform: translateY(-4rpx);
    }
    .bot-row {
      display: flex;
      align-items: center;
      height: 50rpx;
      font-size: 24rpx;
      color: #909399;
      text {
        flex: 1;
      }
    }
  }
  /*  详情 */
  .detail-desc {
    background: #fff;
    margin-top: 16rpx;
    .d-header {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 80rpx;
      font-size: 30rpx;
      color: #303133;
      position: relative;

      text {
        padding: 0 20rpx;
        background: #fff;
        position: relative;
        z-index: 1;
      }
      &:after {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%);
        width: 300rpx;
        height: 0;
        content: '';
        border-bottom: 1px solid #ccc;
      }
    }
    .desc-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .desc-image-view {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      image {
        width: 100%;
      }
    }
    .desc-text-view {
      padding: 15rpx;
    }
  }
  /* 规格选择弹窗 */
  .attr-content {
    padding: 30rpx 30rpx 10rpx 30rpx;
    .a-t {
      display: flex;
      .selected-goods-image {
        width: 150rpx;
        height: 150rpx;
        flex-shrink: 0;
        border-radius: 8rpx;
      }
      .right {
        display: flex;
        flex-direction: column;
        padding-left: 24rpx;
        font-size: 26rpx;
        color: #606266;
        line-height: 42 rpx;
        .price {
          font-size: 32rpx;
          color: $primary-color;
          margin-bottom: 10rpx;
        }
        .selected-text {
          margin-right: 10rpx;
        }
      }
    }
    .attr-list {
      display: flex;
      flex-direction: column;
      font-size: 28rpx;
      color: #666;
      padding: 20rpx 0 10rpx;
    }
    .item-list {
      padding: 15rpx 0 0;
      display: flex;
      flex-wrap: wrap;
      position: relative;
      .spec-text {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f5f5f5;
        margin-right: 20rpx;
        margin-bottom: 20rpx;
        border-radius: 100rpx;
        min-width: 60rpx;
        height: 60rpx;
        padding: 0 20rpx;
        font-size: 26rpx;
        color: #333;
      }
      .selected {
        background: $primary-color;
        color: #fff;
      }
      .disableSelect {
        background: #ddd;
        color: #999;
      }
      .step {
        /*background-color: #01aaef !important;*/
      }
    }

    button {
      &::after {
        border: none;
      }
    }
    .btn {
      height: 66rpx;
      line-height: 66rpx;
      border-radius: 100rpx;
      background: #ddd;
      font-size: 30rpx;
      color: #fff;
      margin: 30rpx auto 20rpx;
      margin-bottom: env(safe-area-inset-bottom);
    }
    .select-btn {
      background: linear-gradient(to right, #ffd01e, #ff8917, #ff6034, #ee0a24);
    }
    .action-btn-group {
      display: flex;
      height: 76rpx;
      border-radius: 100px;
      overflow: hidden;
      position: relative;
      margin-left: 0 !important;
      margin-top: 30rpx;
      margin-bottom: env(safe-area-inset-bottom);
      background-color: #ddd;
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        right: 50%;
        transform: translateY(-50%);
        height: 28rpx;
        width: 0;
        border-right: 1px solid rgba(255, 255, 255, 0.5);
      }
      .action-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 100%;
        font-size: 28rpx;
        padding: 0;
        border-radius: 0;
        background: transparent;
      }
      .buy-now-btn {
        background: linear-gradient(to right, #ff6034, #ee0a24);
        border-radius: 0 20px 20px 0;
      }
      .add-cart-btn {
        background: linear-gradient(90deg, #ffd01e, #ff8917);
        border-radius: 20px 0 0 20px;
      }
    }
  }
}
</style>
